exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-container{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 20px;text-align:center;gap:0}.home-title{font-size:36px;font-weight:450;color:#202124;margin:0;font-family:Amazon Ember,system-ui,sans-serif}.home-subtitle{font-size:20px;font-weight:500;color:#5f6368;text-transform:uppercase;letter-spacing:.1em;margin-top:8px}.home-description{font-size:15px;color:#5f6368;max-width:520px;line-height:1.6;margin-top:72px}.home-description+.home-description{margin-top:12px}.home-logo{max-width:100px;height:auto;margin-top:50px}", ""]);

// exports
